package com.deange.nastychristmas.model

import kotlinx.serialization.Serializable

@Serializable
data class Gift(
  val name: String,
)
